import { render, staticRenderFns } from "./AdminEmbroideryCategoriesScreen.vue?vue&type=template&id=00bd52cc&scoped=true&"
import script from "./AdminEmbroideryCategoriesScreen.vue?vue&type=script&lang=js&"
export * from "./AdminEmbroideryCategoriesScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00bd52cc",
  null
  
)

export default component.exports